@import url('https://fonts.googleapis.com/css2?family=Archivo:wght@500;600;700&family=Inter:wght@400;500;600&display=swap');
@import './tokens.css';

*{box-sizing:border-box}
html,body,#root{height:100%}
body{margin:0;background:var(--surface-page);color:var(--text-primary);font-family:var(--font-body);-webkit-font-smoothing:antialiased}
a{color:var(--green-mid)}
a:hover{color:var(--brand)}
button{font-family:var(--font-body)}
.num{font-variant-numeric:tabular-nums}

/* Shell */
.shell{display:flex;height:100%}
.sidebar{width:212px;flex-shrink:0;background:var(--brand);color:var(--paper);padding:20px 14px;display:flex;flex-direction:column;overflow-y:auto}
.sidebar-logo{width:96px;margin:4px 0 26px 6px;display:block}
.nav-item{display:flex;align-items:center;gap:10px;width:100%;padding:9px 12px;border-radius:8px;border:none;background:transparent;color:var(--paper);font-size:14px;text-align:left;cursor:pointer;opacity:.78;transition:background-color .12s ease,opacity .12s ease}
.nav-item:hover{opacity:1;background:rgba(255,255,255,.07)}
.nav-item.active{opacity:1;background:rgba(255,255,255,.14)}
.nav-item.quarantine{opacity:1;background:rgba(224,138,31,.18)}
.nav-item.quarantine.active{background:rgba(224,138,31,.3)}
.nav-count{margin-left:auto;font-variant-numeric:tabular-nums}
.nav-eyebrow{font:500 10px/1 var(--font-body);letter-spacing:.09em;text-transform:uppercase;opacity:.55;margin:24px 0 8px 12px}
.biz-switch{margin-top:12px;border-top:1px solid rgba(255,255,255,.12);padding-top:12px}
.biz-option{display:block;width:100%;text-align:left;border:none;background:transparent;color:var(--paper);padding:7px 12px;border-radius:8px;font-size:12px;cursor:pointer;opacity:.6}
.biz-option:hover{opacity:.9;background:rgba(255,255,255,.07)}
.biz-option.active{opacity:1;font-weight:500}
.biz-option small{display:block;font-size:11px;opacity:.75;font-weight:400}
.main{flex:1;min-width:0;height:100%;overflow-y:auto}
.page{padding:28px 32px 48px;max-width:1180px}

/* Type helpers */
.eyebrow{font:500 11px/1 var(--font-body);letter-spacing:.08em;text-transform:uppercase;color:var(--stone)}
.h-title{font-family:var(--font-display);font-size:24px;line-height:30px;font-weight:600;margin:0}
.h-section{font-family:var(--font-display);font-size:20px;line-height:26px;font-weight:600;margin:0}
.h-card{font-family:var(--font-display);font-size:16px;font-weight:500}
.muted{color:var(--text-secondary)}
.page-head{display:flex;justify-content:space-between;align-items:flex-end;gap:16px;margin-bottom:22px;flex-wrap:wrap}

/* Surfaces */
.card{background:var(--surface-card);border:1px solid var(--border-default);border-radius:10px;overflow:hidden}
.card-head{padding:14px 20px;border-bottom:1px solid var(--border-default)}
.row-line{display:flex;align-items:center;gap:14px;padding:13px 20px;border-bottom:1px solid var(--border-default)}
.row-line:last-child{border-bottom:none}
.kpis{display:flex;flex-wrap:wrap;gap:14px;margin-bottom:22px}
.kpis > *{flex:1 1 200px;max-width:280px}

/* Tabs */
.tabs{display:flex;gap:22px;border-bottom:1px solid var(--border-default);margin:18px 0 20px;overflow-x:auto}
.tab{font-size:13px;color:var(--text-secondary);padding:0 0 9px;border:none;border-bottom:2px solid transparent;background:none;cursor:pointer;white-space:nowrap}
.tab:hover{color:var(--text-primary)}
.tab.active{color:var(--text-primary);font-weight:500;border-bottom-color:var(--brand)}

/* Table interaction */
.tabla-row-click{cursor:pointer;transition:background-color .1s ease}
.tabla-row-click:hover{background:var(--surface-sunken)}
.tabla-row-selected{background:#EAF0EC}
.tabla-row-selected:hover{background:#E1EAE4}

/* Day ledger */
.ledger{background:var(--paper);background-image:linear-gradient(var(--paper-border) 1px,transparent 1px);background-size:100% 28px}

/* Month strip */
.strip{display:grid;grid-template-columns:repeat(14,1fr);gap:6px}
.strip-day{aspect-ratio:1;border-radius:6px;display:flex;flex-direction:column;align-items:center;justify-content:center;gap:1px;cursor:pointer;padding:0;font-family:var(--font-body);transition:transform .08s ease}
.strip-day:hover{transform:translateY(-1px)}
.strip-day.sel{outline:2px solid var(--brand);outline-offset:1px}
.strip-day.ok{background:rgba(30,122,77,.12);border:1px solid rgba(30,122,77,.35);color:var(--state-ok)}
.strip-day.error{background:rgba(194,53,43,.14);border:1px solid var(--state-error);color:var(--state-error)}
.strip-day.pend{background:var(--surface-sunken);border:1px dashed var(--state-pending);color:var(--state-pending)}
.strip-day .d{font-size:10px;font-variant-numeric:tabular-nums}
.strip-day .m{font-size:11px;line-height:11px;font-weight:700}

/* Chat + proposal */
.build{display:flex;height:100%}
.build-chat{width:440px;min-height:0;flex-shrink:0;border-right:1px solid var(--border-default);background:var(--paper);display:flex;flex-direction:column}
.build-thread{flex:1;min-height:0;overflow-y:auto;padding:22px 20px;display:flex;flex-direction:column;gap:12px}
.build-sheet{flex:1;min-width:0;display:flex;flex-direction:column;overflow:hidden}
.chip{border:1px solid var(--border-default);background:var(--surface-card);color:var(--brand);font-size:13px;padding:6px 11px;border-radius:999px;cursor:pointer;text-align:left}
.chip:hover{background:var(--surface-sunken);border-color:var(--brand-mid)}
.chip[aria-pressed="true"]{background:#EAF0EC;border-color:var(--brand-mid);font-weight:600}
.typing{display:inline-flex;gap:4px;padding:14px 16px;background:var(--surface-card);border:1px solid var(--border-default);border-radius:10px;width:max-content}
.typing span{width:6px;height:6px;border-radius:50%;background:var(--stone);animation:blink 1s infinite ease-in-out}
.typing span:nth-child(2){animation-delay:.15s}
.typing span:nth-child(3){animation-delay:.3s}
.build-head{display:flex;align-items:center;gap:8px;padding:10px 14px;border-bottom:1px solid var(--border-default)}
.build-head-title{flex:1;min-width:0;font-size:13px;color:var(--text-secondary);white-space:nowrap;overflow:hidden;text-overflow:ellipsis}
.build-history{flex:1;min-height:0;overflow-y:auto;padding:10px;display:flex;flex-direction:column;gap:4px}
.build-history-item{display:flex;flex-direction:column;gap:3px;width:100%;text-align:left;font:inherit;border:1px solid transparent;background:none;border-radius:8px;padding:10px 12px;cursor:pointer;color:var(--text-primary)}
.build-history-item:hover{background:var(--surface-sunken)}
.build-history-item.active{background:var(--surface-card);border-color:var(--border-default)}
.build-history-item .t{font-size:14px;line-height:20px;overflow:hidden;display:-webkit-box;-webkit-line-clamp:2;-webkit-box-orient:vertical}
.build-history-item .m{font-size:12px;color:var(--text-secondary);display:flex;gap:6px;align-items:center;flex-wrap:wrap}
@keyframes blink{0%,80%,100%{opacity:.25}40%{opacity:1}}

/* Split: table + side panel */
.split{display:flex;gap:0;align-items:stretch;min-height:100%}
.split-main{flex:1;min-width:0;padding:24px 26px 40px}
.split-panel{width:462px;flex-shrink:0;border-left:1px solid var(--border-default);background:var(--paper-bone);padding:22px 20px 40px}

/* Receipt */
.receipt{background:var(--paper-bone);box-shadow:0 1px 3px rgba(0,0,0,.08);padding:24px 24px 0}
.receipt-tear{height:12px;background:repeating-linear-gradient(-45deg,var(--paper-bone) 0 8px,transparent 8px 16px)}
.dashed{border-top:1px dashed var(--paper-border)}

/* Modal + toast */
.overlay{position:fixed;inset:0;background:rgba(26,26,23,.35);display:flex;align-items:center;justify-content:center;padding:16px;z-index:50;animation:fade .12s ease}
.modal{background:var(--surface-page);border:1px solid var(--border-default);border-radius:16px;box-shadow:var(--shadow-elevated);width:100%;max-width:520px;max-height:calc(100vh - 32px);overflow-y:auto}
.modal-head{display:flex;align-items:flex-start;justify-content:space-between;gap:16px;padding:20px 24px 14px}
.modal-body{padding:0 24px 20px;display:flex;flex-direction:column;gap:14px}
.modal-foot{display:flex;justify-content:flex-end;gap:10px;padding:14px 24px;border-top:1px solid var(--border-default);background:var(--paper-bone)}
.icon-btn{border:none;background:transparent;cursor:pointer;padding:6px;border-radius:6px;color:var(--text-secondary);display:inline-flex}
.icon-btn:hover:not(:disabled){background:var(--surface-sunken);color:var(--text-primary)}
.icon-btn:disabled{opacity:.35;cursor:default}
.toast{position:fixed;right:20px;bottom:20px;z-index:60;background:var(--brand);color:var(--paper);padding:12px 16px;border-radius:10px;box-shadow:var(--shadow-elevated);font-size:14px;display:flex;gap:10px;align-items:center;max-width:420px;animation:rise .18s ease}
@keyframes fade{from{opacity:0}to{opacity:1}}
@keyframes rise{from{opacity:0;transform:translateY(8px)}to{opacity:1;transform:none}}
.dropzone{border:1px dashed var(--paper-border);border-radius:10px;background:var(--surface-sunken);padding:28px;text-align:center;font-size:14px;color:var(--text-secondary)}
textarea.field{width:100%;min-height:84px;resize:vertical;border:1px solid var(--border-default);border-radius:6px;background:var(--surface-card);padding:10px 12px;font:15px/22px var(--font-body);color:var(--text-primary);outline:none}
textarea.field:focus{border-color:var(--brand-mid)}
.back-link{display:inline-flex;align-items:center;gap:6px;font-size:13px;color:var(--brand-mid);background:none;border:none;padding:0;cursor:pointer;margin-bottom:14px}
.back-link:hover{color:var(--brand)}

@media (max-width: 1100px){
  .split{flex-direction:column}
  .split-panel{width:auto;border-left:none;border-top:1px solid var(--border-default)}
  .build{flex-direction:column;height:auto;min-height:100%}
  .build-chat{width:auto;border-right:none;border-bottom:1px solid var(--border-default);height:85vh;min-height:420px}
}
.topbar{display:none}
.drawer-scrim{display:none}
@media (max-width: 820px){
  .shell{flex-direction:column;height:auto;min-height:100%}
  .topbar{display:flex;align-items:center;gap:12px;position:sticky;top:0;z-index:30;background:var(--brand);color:var(--paper);padding:10px 16px}
  .topbar img{width:64px;display:block}
  .topbar .where{font-size:13px;opacity:.8;min-width:0;white-space:nowrap;overflow:hidden;text-overflow:ellipsis;flex:1}
  .menu-btn{border:1px solid rgba(255,255,255,.25);background:transparent;color:var(--paper);border-radius:8px;width:40px;height:40px;display:inline-flex;align-items:center;justify-content:center;cursor:pointer;flex-shrink:0}
  .sidebar{position:fixed;top:0;bottom:0;left:0;width:min(300px,86vw);z-index:45;transform:translateX(-100%);transition:transform .18s ease;box-shadow:var(--shadow-elevated)}
  .sidebar.open{transform:none}
  .sidebar .sidebar-logo{margin-bottom:18px}
  .drawer-scrim.open{display:block;position:fixed;inset:0;background:rgba(26,26,23,.4);z-index:40}
  .main{height:auto;overflow:visible}
  .page{padding:20px 16px 40px}
  .strip{grid-template-columns:repeat(7,1fr)}
}

/* Signal badge (employee view without signal) */
.signal{border:1px solid rgba(255,255,255,.35);background:transparent;color:var(--paper);font-size:11px;border-radius:999px;padding:3px 9px;cursor:pointer}
.signal.off{background:var(--amber);border-color:var(--amber);color:var(--ink-text)}

/* Phase switch + onboarding */
.fase-switch{display:flex;gap:2px;background:rgba(255,255,255,.08);border-radius:8px;padding:2px;margin:10px 0 0}
.fase-switch button{flex:1;border:none;background:transparent;color:var(--paper);font-size:12px;padding:6px 4px;border-radius:6px;cursor:pointer;opacity:.65;white-space:nowrap}
.fase-switch button.active{background:rgba(255,255,255,.18);opacity:1;font-weight:500}
.steps{display:grid;grid-template-columns:repeat(auto-fit,minmax(200px,1fr));gap:1px;background:var(--border-default)}
.step{background:var(--surface-card);padding:14px 16px;display:flex;flex-direction:column;gap:6px}
.step-n{width:22px;height:22px;border-radius:50%;display:inline-flex;align-items:center;justify-content:center;font-size:12px;font-weight:600;border:1px solid var(--paper-border);color:var(--text-secondary)}
.step.done .step-n{background:var(--state-ok);border-color:var(--state-ok);color:#fff}
.step.current{background:var(--paper-bone);box-shadow:inset 0 2px 0 var(--amber)}
